<template>
  <a-spin :spinning="formOption.busy">

    <a-form :form="form"
            :label-col="{ span: 12 }"
            :wrapper-col="{ span: 12 }"
    >
      <div class="form_title">参与规则设置</div>
      <a-row :gutter="24">
        <a-col>
          <a-form-item label="活动期间每人共可参与"
                       :label-col="{ span: 8 }"
                       :wrapper-col="{ span: 12 }">
            <a-input-number v-decorator="['totalJoinNum',rules.totalJoinNum]" :min="1" :max="10000"/>
            <span class="times">次奖</span>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col>
          <a-form-item label="活动期间每人每日可参与"
                       :label-col="{ span: 8 }"
                       :wrapper-col="{ span: 12 }">
            <a-input-number v-decorator="['dayJoinNum',rules.dayJoinNum]" :min="1" :max="10000"/>
            <span class="times">次奖</span>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col>
          <a-form-item label="活动期间每人可中"
                       :label-col="{ span: 8 }"
                       :wrapper-col="{ span: 12 }">
            <a-input-number v-decorator="['winNum',rules.winNum]" :min="1" :max="10000"/>
            <span class="times">次奖</span>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col>
          <a-form-item label="活动期间每人每日分享增加抽奖"
                       :label-col="{ span: 8 }"
                       :wrapper-col="{ span: 12 }">
            <a-input-number v-decorator="['shareAddTimes',rules.shareAddTimes]" :min="1" :max="10000"/>
            <span class="times">次奖</span>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col>
          <a-form-item label="活动期间每人总分享增加抽奖"
                       :label-col="{ span: 8 }"
                       :wrapper-col="{ span: 12 }">
            <a-input-number v-decorator="['shareAddTotalTimes',rules.shareAddTotalTimes]" :min="1" :max="10000"/>
            <span class="times">次奖</span>
          </a-form-item>
        </a-col>
      </a-row>
      <div class="form_title">参与标签设置</div>
      <div>标签规则
        <a-button @click="add(0)">添加规则</a-button>
      </div>
      <div v-for="(item,index) in tagRuleList" :key="item.tagRuleId" v-show="isAutoTag">
        <div class="rule-item">
          <h3>微信用户:</h3>
          <a-select v-model="item.ruleId" :options="ruleTypeOptions" style="width: 200px"></a-select>
          <template><span>时</span></template>
          <!--          <a-select-->
          <!--              mode="multiple"-->
          <!--              v-model="item.tagIds"-->
          <!--              :options="tagOptions"-->
          <!--              style="width: 300px"-->
          <!--              @change="handleChange"-->
          <!--          >-->
          <!--          </a-select>-->
          <tagPicker v-model="item.tagId" style="width: 300px"></tagPicker>
          <a-icon type="plus-circle" @click="add(index)"/>
          <a-icon type="minus-circle" @click="delItem(index)"/>
        </div>
      </div>
    </a-form>

    <a-space class="a-form-btn-box">
      <a-button @click="lastStep">上一步</a-button>
<!--      <a-button type="primary" @click="submit">下一步</a-button>-->
      <a-button type="primary" @click="_save()">下一步</a-button>
    </a-space>
  </a-spin>
</template>

<script>
import {formMixin, fmt} from '@/utils/common/FormBase'
import {dataApi} from "@/services/market/active";
import tagPicker from '@/components/picker/scrmTagPicker.vue';

/**
 * 加载规则 必填控制我
 */
function getRulesTemplate() {
  return {
    totalJoinNum: {
      rules: [{required: true, message: "请输入活动期间共参与次数"}]
    },
    dayJoinNum: {
      rules: [{required: true, message: "请输入活动期间每日参与次数"}]
    },
    winNum: {
      rules: [{required: true, message: "请输入活动期间可中奖次数"}]
    },
    shareAddTimes: {
      rules: [{required: true, message: "请输入活动期间每人每日分享增加次数"}]
    },
    shareAddTotalTimes: {
      rules: [{required: true, message: "请输入活动期间每人总分享增加次数"}]
    }
  };
}


/**
 * 新建表单数据 没有预设可以不写  预设的值可以在afterLoad之中调用到
 * 一般是用来写表单默认值 或者写不在表单中需要保存的值
 * @returns {Object}
 */
function newEntity() {
  return {
    isAutoTag: true
  };
}


/**
 * 加载数据
 * @param rowId 主键值
 * @returns {Promise}
 */
async function loadEntity(rowId) {

  let entity = await dataApi.getFormDetail(rowId);
  this.detail = entity.data
  this.labelOptions = entity.data.prizeList.map(item => {
    return {
      title: item.prizeRank,
      key: item.prizeId
    }
  })
  if (entity.data.tagRuleList && entity.data.tagRuleList.length > 0) {
    this.tagRuleList = entity.data.tagRuleList
  }
  return fmt.formatFormLoad(entity);
}


/**
 * 加载数据之后执行的函数(新建表单也会执行)
 */
async function afterLoad(entity) {
  console.log(entity)
}


/**
 * 提交数据
 * @param entities
 * @param vm
 * @returns {Promise}
 * 修改时间2022/7/12 新增字段 判断合理性
 */
async function save(entities){
  if(entities.dayJoinNum > entities.totalJoinNum){
    throw '活动期间每人每日可参与次数不能多于每人共可参与次数'
  }
  if(entities.shareAddTimes > entities.shareAddTotalTimes){
    throw '活动期间每人每日分享增加次数不能多于每人总分享增加次数'
  }
  let params = this.detail
  Object.assign(params, entities)
  await dataApi.saveFormDetail(params).then(res => {
    if (res.code === 200) {
      this.$emit('nextStep', res.data.actId)
    } else {
      this.$message.error(res.msg)
    }
  })
}
/**
 * submit
 * 原方法
 */
// function submit() {
//   this.form.validateFieldsAndScroll((err, values) => {
//     if (!err) {//无任何错误 向下执行
//       console.log(this.detail);
//       let params = this.detail
//       Object.assign(params, values)
//       dataApi.saveFormDetail(params).then(res => {
//         if (res.code === 200) {
//           this.$emit('nextStep', res.data.actId)
//         } else {
//           this.$message.error(res.msg)
//         }
//       })
//     }
//   });
//
//
// }

/**
 * 加载基础数据
 */
async function loadBaseData() {
}


/**
 * 表单组件
 */
export default {
  mixins: [formMixin],
  components: {tagPicker},
  data() {
    return {
      isAutoTag: true,
      tagRuleList: [{ruleId: 1, actId: this.rowId, tagId: ''}],
      ruleTypeOptions: [{title: '参与活动', key: 1}, {title: '进入页面', key: 2}, {title: '抽中奖品', key: 3}, {
        title: '转发活动',
        key: 4
      }],
      labelOptions: [],
      tagOptions: [],
      detail: null
    }
  },
  mounted() {
    console.log(this.rowId)
    // 切换页面时滚动条自动滚动到顶部
    window.scrollTo(0, 0);
  },
  methods: {
    loadEntity,
    newEntity,
    // submit,
    save,
    getRulesTemplate,
    afterLoad,
    loadBaseData,
    add(index) {
      const item = {ruleId: 1, actId: this.rowId, tagId: ''}
      this.tagRuleList.splice(index + 1, 0, item)
    },
    delItem(index) {
      // if (this.tagRuleList.length <= 1) {
      //   this.$message.error('请至少填写一条规则')
      //   return false
      // }
      this.tagRuleList.splice(index, 1)
    },
    lastStep() {
      this.$emit('lastStep')
    },
    handleChange() {
      this.$forceUpdate()
    }
  }
};
</script>
<style lang="less" scoped>
.rule-item {
  display: flex;
  margin-top: 12px;
  line-height: 30px;

  h3 {
    width: 80px;
  }

  span {
    display: inline-block;
    width: 60px;
    text-align: center;
  }

  i {
    font-size: 24px;
    margin-left: 12px;
    color: #D90B18;
    cursor: pointer;
  }
}

/deep/ .ant-form-item-children {
  display: flex;

  .times {
    margin-left: 12px;
    width: 50px;
  }
}
</style>
